import { Tag as TagType } from "entities/shared/tags.types";
import styles from "./TagsList.module.scss";

import { useTagsContext } from "../../Tags.context";
import { Tag } from "../Tag";

export const TagsList: RFC = () => {
  const { tagsList, activeTag, openTag } = useTagsContext();

  const renderTags = () => {
    if (activeTag) {
      return (
        <div className={styles.tagItem}>
          <Tag name={activeTag} isActive={true} />
        </div>
      );
    }

    return tagsList.map((item: TagType) => (
      <div
        key={item.name}
        className={styles.tagItem}
        onClick={() => openTag(item.name)}
        data-test-id={`tag-button-${item.name}`}
      >
        <Tag name={item.name} isActive={false} />
      </div>
    ));
  };

  return <div className={styles.tagsList}>{renderTags()}</div>;
};
